import { render, staticRenderFns } from "./Island3.vue?vue&type=template&id=bdb7a9f0"
import script from "./Island3.vue?vue&type=script&lang=js"
export * from "./Island3.vue?vue&type=script&lang=js"
import style0 from "./Island3.vue?vue&type=style&index=0&id=bdb7a9f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports